const {Howl} = require('howler');

export class backAudio {
    constructor() {
      this.audio = document.getElementById('background-music');

      if (this.audio) {

        // let source = audio.querySelector('source').getAttribute('src');
        console.log(this.audio);
        this.audio.autoplay = true;
        this.audio.load();

        this.setEvents();
      }
    }

    setEvents() {
      // this.audio.addEventListener('click', (e) => this.playAudio(e));
      window.addEventListener('load', () => this.playAudio());
    }

    fetchAndPlay() {
      let src = this.audio.querySelector('source').getAttribute('src');

      var sound = new Howl({
        src: [src],
        autoplay: true,
        loop: true,
        volume: 0.3,
      });

      setTimeout(() => {
        document.querySelector('body').click();
        sound.once('load', () => {
          sound.play();
        });
      },500);

      // fetch(src)
      //   .then(response => response.blob())
      //   .then(blob => {
      //     console.log(blob);
      //     // this.audio.srcObject = blob;
      //
      //     return this.audio.play();
      //   })
      //   .then(e => {
      //     // Video playback started ;)
      //     console.log(e);
      //   })
      //   .catch(e => {
      //     // Video playback failed ;(
      //     console.log(e);
      //   })
    }

    playAudio() {
      let src = this.audio.querySelector('source').getAttribute('src');

      this.sound = new Howl({
        src: [src],
        autoplay: true,
        loop: true,
        volume: 0.2,
      });

      this.sound.once('load', () => {
        if ( !this.sound.playing() ) {
          this.sound.play();
        }
      });
    }
}
